(() => {
  // Delegate so stock-aware actions also work inside the asynchronously rendered review widget.
  document.addEventListener('click', event => {
    const action = event.target.closest?.('[data-koppa-purchase-focus]');
    if (!action) return;
    const panel = action.closest('.pp')?.querySelector('#product-purchase');
    if (!panel) return;
    event.preventDefault();
    const target = panel.querySelector('input[type="email"], [data-ploy-variant], button[type="submit"]');
    if (target) {
      let ancestor = target.parentElement;
      while (ancestor && ancestor !== panel) {
        if (ancestor.tagName === 'DETAILS') ancestor.open = true;
        ancestor = ancestor.parentElement;
      }
    }
    (target || panel).scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    target?.focus({preventScroll:true});
  });
  function init(root) {
    root.querySelectorAll('.protocol-purchase').forEach(panel => {
      if (panel.dataset.purchaseReady) return;
      panel.dataset.purchaseReady = 'true';
      const page = panel.closest('.pp');
      const form = panel.querySelector('.protocol-restock-form');
      const email = form?.querySelector('input[type="email"]');
      const primary = panel.querySelector('button[type="submit"]');
      const focusForm = () => {
        panel.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        (email || primary)?.focus({preventScroll:true});
      };
      page.querySelectorAll('[data-protocol-focus]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); focusForm(); }));
      if (!email || !primary) return;
      const sticky = document.createElement('div');
      sticky.className = 'protocol-mobile-action';
      sticky.hidden = true;
      const price = document.createElement('span');
      price.textContent = panel.querySelector('.protocol-price').textContent.trim();
      const action = document.createElement('button');
      action.type = 'button';
      action.textContent = primary.textContent.trim();
      action.addEventListener('click', focusForm);
      sticky.append(price, action);
      page.append(sticky);
      const update = () => {
        const rect = form.getBoundingClientRect();
        const visible = rect.bottom > 0 && rect.top < innerHeight;
        sticky.hidden = !matchMedia('(max-width:767px)').matches || visible || rect.bottom > 0 || panel.contains(document.activeElement) || [...document.querySelectorAll('dialog[open], [aria-modal="true"]')].some(dialog => { const box = dialog.getBoundingClientRect(); return dialog.checkVisibility({visibilityProperty:true}) && box.width > 0 && box.right > 0 && box.left < innerWidth && box.bottom > 0 && box.top < innerHeight; });
      };
      let frame = 0;
      const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); };
      window.addEventListener('scroll', schedule, {passive:true});
      window.addEventListener('resize', schedule, {passive:true});
      document.addEventListener('focusin', schedule);
      document.addEventListener('focusout', schedule);
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(panel)) return;
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', schedule);
        document.removeEventListener('focusin', schedule);
        document.removeEventListener('focusout', schedule);
        cancelAnimationFrame(frame);
        sticky.remove();
      });
      update();
    });

    root.querySelectorAll('[data-ploy-variant]').forEach((select) => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        // Render prices and selling-plan allocations from Shopify for this variant.
        const url = new URL(location.href);
        url.searchParams.set('variant', select.value);
        location.assign(url.href);
      });
    });
    root.querySelectorAll('[data-ploy-product-gallery]').forEach((gallery) => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const track = gallery.querySelector('[data-ploy-gallery-track]');
      const slides = Array.from(gallery.querySelectorAll('[data-ploy-gallery-slide]'));
      const thumbs = Array.from(gallery.querySelectorAll('[data-ploy-gallery-thumb]'));
      const count = gallery.querySelector('[data-ploy-gallery-count]');
      const previous = gallery.querySelector('[data-ploy-gallery-previous]');
      const next = gallery.querySelector('[data-ploy-gallery-next]');
      let current = 0;
      let startX = null;
      let resizeFrame = 0;
      const imageRatio = (slide) => {
        const image = slide?.querySelector('img');
        const source = [...(image?.closest('picture')?.querySelectorAll('source') || [])].find(item => !item.media || matchMedia(item.media).matches);
        const width = Number(source?.getAttribute('width')) || image?.naturalWidth || Number(image?.getAttribute('width')) || 4;
        const height = Number(source?.getAttribute('height')) || image?.naturalHeight || Number(image?.getAttribute('height')) || 5;
        return width / height;
      };
      const fitImage = () => {
        const uniform = gallery.hasAttribute('data-koppa-uniform-gallery');
        const isDesktop = window.matchMedia('(min-width: 768px)').matches;
        const ratio = uniform && isDesktop ? 0.8 : imageRatio(slides[current]);
        const stage = gallery.querySelector('.product-gallery__stage');
        const viewport = gallery.querySelector('.product-gallery__viewport');
        const mobileProperties = {
          height: 'auto', 'min-height': '0', 'max-height': 'none',
          'aspect-ratio': String(ratio), width: '100%'
        };
        [stage, viewport].forEach(node => {
          if (!node) return;
          Object.entries(mobileProperties).forEach(([key, value]) => {
            if (isDesktop) node.style.removeProperty(key);
            else node.style.setProperty(key, value, 'important');
          });
        });
        const styles = getComputedStyle(gallery);
        const availableWidth = gallery.clientWidth - (isDesktop ? 76 + (parseFloat(styles.columnGap) || 12) : 0);
        if (availableWidth <= 0) return;
        const maxHeight = Math.max(160, window.innerHeight - (isDesktop ? 220 : 160));
        const frameHeight = !isDesktop ? availableWidth / ratio : uniform
          ? (isDesktop ? Math.min(maxHeight, availableWidth / 0.8) : availableWidth / 0.8)
          : Math.min(maxHeight, Math.max(...slides.map(slide => availableWidth / imageRatio(slide))));
        const mediaWidth = Math.min(availableWidth, frameHeight * ratio);
        gallery.style.setProperty('--koppa-gallery-frame-height', frameHeight + 'px');
        gallery.style.setProperty('--koppa-gallery-aspect', ratio);
        gallery.style.setProperty('--koppa-gallery-media-width', mediaWidth + 'px');
        gallery.style.setProperty('--koppa-gallery-media-height', mediaWidth / ratio + 'px');
      };
      const scheduleFit = () => {
        cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(fitImage);
      };
      const show = (index) => {
        if (!slides.length) return;
        current = (index + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (current * 100) + '%)';
        thumbs.forEach((thumb, thumbIndex) => {
          const active = thumbIndex === current;
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
          thumb.classList.toggle('border-ploy-text-primary', active);
          thumb.classList.toggle('opacity-100', active);
          thumb.classList.toggle('border-ploy-border-primary', !active);
          thumb.classList.toggle('opacity-55', !active);
        });
        if (count) count.textContent = (current + 1) + ' / ' + slides.length;
        fitImage();
      };
      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
      previous?.addEventListener('click', () => show(current - 1));
      next?.addEventListener('click', () => show(current + 1));
      gallery.addEventListener('touchstart', (event) => { startX = event.touches[0]?.clientX ?? null; }, { passive: true });
      gallery.addEventListener('touchend', (event) => {
        if (startX === null) return;
        const distance = (event.changedTouches[0]?.clientX ?? startX) - startX;
        if (Math.abs(distance) > 45) show(current + (distance < 0 ? 1 : -1));
        startX = null;
      }, { passive: true });
      slides.forEach(slide => slide.querySelector('img')?.addEventListener('load', scheduleFit));
      let previousWidth = 0;
      const observer = new ResizeObserver(entries => {
        const width = entries[0]?.contentRect.width;
        if (width !== previousWidth) { previousWidth = width; scheduleFit(); }
      });
      observer.observe(gallery);
      window.addEventListener('resize', scheduleFit, { passive: true });
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(gallery)) return;
        observer.disconnect();
        window.removeEventListener('resize', scheduleFit);
        cancelAnimationFrame(resizeFrame);
      });
      show(0);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
